import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-container">
              <img src="/logo.jpeg" alt="Shachar High-Tech Logo" className="footer-logo-image" />
              <div className="footer-logo-text">
                <h3>Shachar High-Tech</h3>
                <span>Software Development</span>
              </div>
            </div>
            <p className="footer-description">
              Professional software development services specializing in Cloud services, 
              Machine Learning, and Data Analysis.
            </p>
            <div className="footer-contact">
              <p>◉ 3 HaNechoshet St. Suite B/36, Tel Aviv, 6971068</p>
              <p>✉ info@shachar-ht.com</p>
              <p>☎ +972 54 4745666</p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li>Cloud Services (AWS)</li>
              <li>Machine Learning</li>
              <li>Data Analysis</li>
              <li>Custom Development</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li>About Us</li>
              <li>Our Team</li>
              <li>Careers</li>
              <li>Contact</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              <a href="#" className="social-link">LinkedIn</a>
              <a href="#" className="social-link">GitHub</a>
              <a href="#" className="social-link">Twitter</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2024 Shachar High-Tech Software Development. All rights reserved.</p>
            <button className="back-to-top" onClick={scrollToTop}>
              ↑ Back to Top
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
